<template>
    <div class="password-reissue-body" v-loading.fullscreen.lock="is_loading">
        <div class="password-reissue-area">
            <h4 class="content-sub-title">{{ $t('password_reissue.index.reset_password')}}</h4>
            <!-- パスワード再設定 メールアドレス入力 説明書き -->
            <div class="password-reissue-description" v-html="$t('password_reissue.index.description')" />
            <div class="password-reissue-form">
                <el-form @submit.native.prevent="onReissue" ref="reset_form" :rules="rules" :model="reset_form">
                    <!-- メールアドレス -->
                    <el-form-item :label="$t('attributes.mail_address')" prop="email">
                        <el-input class="input-text-free" clearable v-model="reset_form.email" ref="email" />
                    </el-form-item>
                </el-form>
            </div>

            <div class="button-block">
                <el-button type="primary" @click="onReissue">{{ $t("password_reissue.index.reset_password") }}</el-button>
                <el-button @click="onBack">{{ $t('attributes.back') }}</el-button>
            </div>
        </div>
    </div>
</template>

<style lang="sass">
/* CSSファイルの読み込み */
@import '../../../sass/auth/password-reissue/common.scss'
</style>

<script>
import common from '../../common/common';
import axios from 'axios';

export default {
    data() {
        return {
            is_loading: false,
            reset_form: {
                email: ''
            },
            rules: {
                email: [
                    {
                        required: true,
                        message: this.$t('password_reissue.index.errors.required_email'),
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        message: this.$t(
                            'password_reissue.index.errors.email_incorrect_format'
                        ),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    methods: {
        onReissue() {
            // パスワード再設定
            this.$refs['reset_form'].validate(valid => {
                if (valid) {
                    this.is_loading = true;

                    const params = {
                        email: this.reset_form.email
                    }

                    axios
                        .post('/api/password/reissue', params)
                        .then(response => {
                            this.$router.push({ name: 'password-reissue-done' });
                        })
                        .catch(error => {
                            this.$message.error({ showClose: true, message: common.getErrorMessage(error.response.data) });
                        })
                        .finally(() => this.is_loading = false);
                }
            });
        },
        onBack() {
            this.$router.push({ name: 'login' });
        }
    }
};
</script>
